import * as React from "react";

const Ststistic = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="svg1"
    width="24"
    height="24"
    version="1.1"
    viewBox="0 0 6.35 6.35"
  >
    <g
      id="layer7"
      fill="none"
      fillOpacity="1"
      stroke="#000"
      strokeDasharray="none"
      strokeDashoffset="0.92"
      strokeLinecap="round"
      strokeLinejoin="miter"
      strokeOpacity="1"
      strokeWidth="0.4"
    >
      <path
        id="rect19"
        d="M.794 2.91h.529a.265.265 45 0 1 .264.265v2.381a.265.265 135 0 1-.264.265h-.53a.265.265 45 0 1-.264-.265V3.175a.265.265 135 0 1 .265-.265Z"
        opacity="1"
      ></path>
      <path
        id="rect19-4"
        d="M2.91.53h.53a.265.265 45 0 1 .264.264v4.762a.265.265 135 0 1-.264.265h-.53a.265.265 45 0 1-.264-.265V.794A.265.265 135 0 1 2.91.529Z"
      ></path>
      <path
        id="rect19-4-4"
        d="M2.91 1.852h.53a.265.265 45 0 1 .264.265v3.44a.265.265 135 0 1-.264.264h-.53a.265.265 45 0 1-.264-.265v-3.44a.265.265 135 0 1 .264-.264Z"
        transform="translate(2.117)"
      ></path>
    </g>
  </svg>
);

export default Ststistic;
